export enum HotelConfirmStatus {
  Yes = 'Yes',
  No = 'No',
}
